import { useEffect } from 'react';

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum - Erik Schott";
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content-wrapper">
          <div className="content-head">
            <h1 className="h1">Impressum</h1>
          </div>
          <div style={{ alignItems: "center" }} className="input-wrapper">


            <h2 className="h5">Angaben gemäß § 5 DDG</h2>
            <div className="container">
              <div className="bodycopy">
                <em>Adresse</em><br/>
                Erik Schott<br />
                Roosevelt Avenue 18<br />
                61231 Bad Nauheim<br />
                Deutschland<br />
              </div>
              <div className="bodycopy">
                <em>Kontakt</em><br/>
                Tel.: +49 175 7331561<br />
                E-Mail: schott.film.production@gmail.com<br/>
                Website: schott.film.production.de<br />
              </div>
              <div className="bodycopy">
                <em>Vertretungsberechtiger</em><br/>
                Erik Schott (Geschäftsleitung)<br />
              </div>
            </div>
            <h2 className="h5">Haftung</h2>
            <div className="container">
                <div className="bodycopy">
                    Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Haftung übernommen werden. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten verantwortlich. Nach den allgemeinen Gesetzen sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
                </div>
                <div className="bodycopy">
                Unsere Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Die jeweiligen Anbieter oder Betreiber der Seiten sind stets für die Inhalte der verlinkten Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                </div>
            </div>
            <h2 className="h5">Urheberrecht & Datenschutz</h2>
            <div className="container">
                <div className="bodycopy">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                </div>
                <div className="bodycopy">
                    Weitere Informationen zum Datenschutz finden Sie in meiner <a href="/datenschutz">Datenschutzerklärung</a>.
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}